<div class="card-custom code_box code_details_box mb-10">
    <div class="code_details_title">
        <div class="row">
            <div class="col-lg-8 col-xxl-9">
                 <div class="title-wrap" *ngIf="noTool">
                    <h5>
                        No tool available to select.

                    </h5>
                </div>

                <div class="title-wrap" *ngIf="selectedTool?.name  && !noTool">
                    
                    <div  class="col">
                    <h5>
                        Tool Selected 

                    </h5>
                      <h5>
                         <span class="title-wrap-span">{{selectedTool?.manufacturer?.name}} {{selectedTool?.name}}   </span>

                    </h5>
                    </div>

                </div>
                <div class="title-wrap-nodata" *ngIf="!selectedTool?.name && !noTool">
                    <h5>
                        Tool not selected

                    </h5>
                </div>
            </div>
            <div class="col-lg-4 col-xxl-3" *ngIf="!noTool">
                <div class="btn-wrap">

                    <button class="btn btn-sm primary-ebtn" *ngIf="selectedTool?.name" (click)="selectTool(1)">
                        Change Tool
                    </button>
                    <button class="btn btn-sm primary-ebtn" *ngIf="!selectedTool?.name" (click)="selectTool(2)">
                        Select Tool
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>